<template>
    <div>
        <h3>道具包配置</h3>
        <el-form :inline="true" class="demo-form-inline" :loading="loading" size="mini">
            <el-form-item label="道具包名称">
                <el-input placeholder="道具包名称" v-model="filter.toolName"></el-input>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="filter.status">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(label, key) in status" :key="key" :label="label" :value="key"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="上架时间">
                <el-date-picker v-model="filter.launchTimeStart" type="datetime" placeholder="开始时间"
                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="到">
                <el-date-picker v-model="filter.launchTimeEnd" type="datetime" placeholder="结束时间"
                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="下架时间">
                <el-date-picker v-model="filter.takedownTimeStart" type="datetime" placeholder="开始时间"
                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="到">
                <el-date-picker v-model="filter.takedownTimeEnd" type="datetime" placeholder="结束时间"
                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="创建时间">
                <el-date-picker v-model="filter.createTimeStart" type="datetime" placeholder="开始时间"
                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="到">
                <el-date-picker v-model="filter.createTimeEnd" type="datetime" placeholder="结束时间"
                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>


            <el-form-item>
                <el-button type="primary" size="mini" @click="fetch(1)">查询</el-button>
                <el-button type="primary" size="mini" @click="rest()">重置</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="list" size="mini">
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="id" label="道具包编号"></el-table-column>
            <el-table-column prop="packageImg" label="道具图片">
                <template slot-scope="scope">
                    <img style="width: 60px;height: 60px;" :src="scope.row.packageImg" alt="">
                </template>
            </el-table-column>
            <el-table-column prop="toolName" label="道具包名称" width="150"></el-table-column>
            <el-table-column prop="status" label="状态">
                <template slot-scope="scope">{{
                    status[scope.row.status]
                }}</template>
            </el-table-column>
            <el-table-column prop="saleCount" label="销量"></el-table-column>
            <el-table-column prop="price" label="价格"></el-table-column>
            <el-table-column prop="propType" label="道具">
                <template slot-scope="scope">投递卡</template>
            </el-table-column>
            <el-table-column prop="totalNum" label="数量"></el-table-column>
            <el-table-column prop="aging" label="有效期"></el-table-column>
            <el-table-column prop="launchTime" label="上架时间" width="180"></el-table-column>
            <el-table-column prop="takedownTime" label="下架时间" width="180"></el-table-column>
            <el-table-column prop="rank" label="排序"></el-table-column>
            <el-table-column prop="createUser" label="创建人"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
            <el-table-column prop="operator" label="操作人"></el-table-column>
            <el-table-column prop="operateTime" label="操作时间" width="180"></el-table-column>
            <!-- <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-dropdown size="medium" @command="handleCommand">
                        <span class="el-dropdown-link">
                            <i class="el-icon-menu" style="font-size: 24px"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="{ action: 'up', data: scope.row }">上架</el-dropdown-item>
                            <el-dropdown-item :command="{ action: 'down', data: scope.row }">下架</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>  -->
        </el-table>
        <br />
        <div>
            <el-pagination background layout="prev, pager, next" :page-size="limit" @current-change="(i) => (pageNum = i)"
                :page-count="pageNum" :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import map from "../../../datamap";
import api from "../../api";
// import newApi from "@/newApi/bean.js";

let { prop } = api;
export default {
    name: "partyBorder",
    data() {
        return {
            map,
            loading: true,
            types: {},
            filter: {
                toolName: "",
                status: "",
                propType: 2,
                launchTimeStart: "",
                launchTimeEnd: "",
                takedownTimeStart: '',
                takedownTimeEnd: '',
                createTimeStart: '',
                createTimeEnd: ''
            },
            list: [],
            total: 0,
            pageNum: 1,
            limit: 20,
            status: {
                1: "售卖中",
                2: "未上架",
                3: "已下架",
            },
        };
    },
    watch: {
        pageNum() {
            this.fetch();
        },
    },
    methods: {

        async fetch(num) {
            if (num == 1) {
                this.pageNum = 1;
            }
            let { toolName, status, launchTimeStart, launchTimeEnd, takedownTimeStart, takedownTimeEnd, createTimeStart, createTimeEnd } = this.filter;
            let args = {
                pageNum: this.pageNum,
                limit: this.limit,
                status,
                propType: 2,
                launchTimeStart: launchTimeStart || "",
                launchTimeEnd: launchTimeEnd || "",
                takedownTimeStart: takedownTimeStart || "",
                takedownTimeEnd: takedownTimeEnd || "",
                createTimeStart: createTimeStart || "",
                createTimeEnd: createTimeEnd || "",
                toolName: toolName,
            };
            let res = await prop.selectTools(args);
            this.list = res.data.data;
            this.total = res.data.pageinfo.totalCount;
        },
        async rest() {
            this.filter = {
                toolName: "",
                status: "",
                propType: 2,
                launchTimeStart: "",
                launchTimeEnd: "",
                takedownTimeStart: '',
                takedownTimeEnd: '',
                createTimeStart: '',
                createTimeEnd: '',
            }
            this.fetch(1);

        },
        handleCommand(command) {
            let action = command.action;
            let data = command.data;
            switch (action) {
                case "up":
                    this.operate(data);
                    break;
                case "down": //发云豆
                    this.operate(data);
                    break;
                default:
            }
        },
        operate() {

        },

        //     this.loading = true;
        //     let { toolName, status, launchTimeStart, launchTimeEnd, takedownTimeStart, takedownTimeEnd, createTimeStart, createTimeEnd } = this.filter;
        //     let obj = {
        //         pageNum: this.pageNum,
        //         limit: this.limit,
        //         toolName,
        //         status,
        //         launchTimeStart: launchTimeStart || "",
        //         launchTimeEnd: launchTimeEnd || "",
        //         takedownTimeStart: takedownTimeStart || "",
        //         takedownTimeEnd: takedownTimeEnd || "",
        //         createTimeStart: createTimeStart || "",
        //         createTimeEnd: createTimeEnd || "",
        //     };

        //     let resp = await bean.export(obj);
        //     let objectUrl = URL.createObjectURL(new Blob([resp.data]));
        //     let link = document.createElement("a");
        //     //   console.log(link);
        //     link.download = decodeURIComponent("云豆明细列表.xlsx");
        //     link.href = objectUrl;
        //     link.click();
        // },
    },
    mounted() {
        this.fetch(1);
    },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/views/prop/partyB/propConfig.vue